<template>
  <v-container class="exclusion-grid">
    <v-row>
      <v-spacer></v-spacer>
      <v-btn @click="saveExclusions">{{ $t('save') }}</v-btn>
<!--      <v-col>-->
<!--        &lt;!&ndash;        <h2>{{ this.title || $t('admin_acc_region.exclusion') }}</h2>&ndash;&gt;-->
<!--        <v-btn id="saveExclusionBtn" variant="primary" @click="saveExclusions">{{ $t('save') }}</v-btn>-->
<!--      </v-col>-->
    </v-row>
    <table class="table table-hover exclusion-table">
      <col>
      <col v-for="item in itemList">
      <thead>
      <tr>
        <th class="fixed-col">Item</th>
        <th v-for="item in itemList">
          {{ item.name_en }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="itemId in Object.keys(itemMap)">
        <td class="fixed-col">{{ itemMap[itemId].name_en }}</td>
        <td v-for="anotherItemId in Object.keys(itemMap)"
            @mouseover.stop="enterCell"
            @mouseleave.stop="leaveCell"
            :class="['exclusion-table-cell', {'self-cell': itemId === anotherItemId}]">
          <b-form-checkbox v-if="itemId !== anotherItemId"
                           :checked="exclusions[itemId].indexOf(anotherItemId) !== -1"
                           @change="checkboxChecked(anotherItemId, itemId)"></b-form-checkbox>
        </td>
      </tr>
      </tbody>
    </table>
  </v-container>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faEdit, faSearch} from '@fortawesome/free-solid-svg-icons'
import $ from 'jquery'
import _ from 'lodash'

library.add(faEdit, faSearch);

export default {
  name: 'ExclusionGrid',
  props: {
    locationId: String,
    regionId: String,
    itemId: String,
    typeId: String,
    tagId: String,
    title: String,
  },
  data() {
    return {
      exclusions: {},
      exclusionFields: [
        {key: 'name_en', label: 'Item'},
        {key: 'checkboxes', label: 'Item Type'},
      ],
      itemMap: {},
    }
  },
  mounted() {
    this.getExclusions();
  },
  computed: {
    exclusionRows() {
      var v = this;
      return Object.keys(this.exclusions).map(function (itemId) {
        return {itemId: itemId, exclusions: v.exclusions[itemId]}
      });
    },
    itemList() {
      return Object.keys(this.itemMap).map((itemId) => this.itemMap[itemId])
    },
  },
  watch: {
    locationId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getExclusions();
      }
    },
    regionId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getExclusions();
      }
    },
    typeId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getExclusions();
      }
    },
  },
  methods: {
    getExclusions() {
      this.$callAPI('aafb/admin/item/exclusion/', {
        location_id: this.locationId,
        region_id: this.regionId,
        item_id: this.itemId,
        type_id: this.typeId,
        tag_id: this.tagId,
        with_items: true,
      }, function (response) {
        this.exclusions = response.body.exclusions;
        this.itemMap = response.body.items;
      });
    },
    saveExclusions() {
      this.$callAPI('aafb/admin/item/exclusion/set/', {
        exclusions: this.exclusions,
      }, function (response) {
        this.$showAlertMessage('Saved Successfully');
        this.getExclusions();
      });
    },
    enterCell(e) {
      if ($(e.target).hasClass('exclusion-table-cell')) {
        $(e.target).parents('table').find('col:eq(' + $(e.target).index() + ')').addClass('hover');
      }

    },
    leaveCell(e) {
      if ($(e.target).hasClass('exclusion-table-cell')) {
        $(e.target).parents('table').find('col:eq(' + $(e.target).index() + ')').removeClass('hover');
      }
    },
    checkboxChecked(itemId, anotherItemId) {
      if (_.indexOf(this.exclusions[itemId], anotherItemId) === -1) {
        this.exclusions[itemId].push(anotherItemId);

        if (_.indexOf(this.exclusions[anotherItemId], itemId) === -1) {
          this.exclusions[anotherItemId].push(itemId);
        }
      } else {
        this.exclusions[itemId].splice(_.indexOf(this.exclusions[itemId], anotherItemId), 1);

        if (_.indexOf(this.exclusions[anotherItemId], itemId) !== -1) {
          this.exclusions[anotherItemId].splice(_.indexOf(this.exclusions[anotherItemId], itemId), 1);
        }
      }
    },
  },
}
</script>

<style scoped lang="less">
#saveExclusionBtn {
  position: absolute;
  top: 0;
  right: 30px;
}

.item-list-table-body {
  svg {
    font-size: 1.5em;
    margin-left: 5px;
  }

  .fa-edit, .fa-trash {
    cursor: pointer;

    &:hover {
      color: #0070ff;
    }
  }
}

.exclusion-table {
  overflow: hidden;

  td, th {
    position: relative;
  }

  col.hover {
    background-color: rgba(0, 0, 0, 0.075);
  }

  .self-cell {
    background-color: rgba(0, 0, 0, 0.275);
  }
}
</style>
